module.exports = __webpack_public_path__ + "img/1.82797de3.jpg";